import { accCheckerMenuItemText } from 'owa-locstrings/lib/strings/acccheckermenuitemtext.locstring.json';
import {
    InfoMailtipAccessibilityChecker,
    InfoMailtipAccessibilityCheckerMultiple,
} from './getAccessibilityMessageViewState.locstring.json';
import loc, { format } from 'owa-localize';

import {
    InfoBarMessageViewState,
    InfoBarMessageRank,
    InfoBarMessageSource,
} from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import { logUsage } from 'owa-analytics';
import { MessagePart } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import {
    MailTipsActionType,
    MailTipsType,
    MailTipsCategory,
    MailtipsActionDatapointName,
} from '../datapoints';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';

/**
 * Returns InfoBarMessageViewState for users who prefer accessible content.
 * Returns NULL if no user prefers accessible content.
 */
export default (
    recipients: EmailAddressWrapper[],
    onAccessibilityCheckerClick: () => void
): InfoBarMessageViewState => {
    if (!recipients.length) {
        return null;
    }

    let messageParts: MessagePart[] = [];

    /**Info bar message string */
    recipients.length === 1
        ? messageParts.push(format(loc(InfoMailtipAccessibilityChecker), recipients[0].Name))
        : messageParts.push(loc(InfoMailtipAccessibilityCheckerMultiple));

    /**Accessibility checker button */
    messageParts.push({
        text: loc(accCheckerMenuItemText),
        action: () => {
            onClickAndLogDatapoint(onAccessibilityCheckerClick, recipients.length);
        },
    });

    return {
        key: 'PreferAccessibleContent',
        messageParts: messageParts,
        rank: InfoBarMessageRank.Info,
        source: InfoBarMessageSource.Compose,
    };
};

/**
 * Utility function that invokes the onClick callback and log datapoint
 * @param onAccessibilityCheckerClick Callback to be executed
 * @param recipientCount  Count of recipients logged in the datapoint
 */
export function onClickAndLogDatapoint(
    onAccessibilityCheckerClick: () => void,
    recipientCount: number
) {
    onAccessibilityCheckerClick();

    //Log datapoint.
    const mailTipsType: MailTipsType =
        recipientCount === 1 ? MailTipsType.SingleRecipient : MailTipsType.MultipleRecipients;

    logUsage(MailtipsActionDatapointName, [
        MailTipsActionType.AccCheckerClick,
        MailTipsCategory.PreferAccessibleContent,
        mailTipsType,
        recipientCount,
    ]);
}
